<ng-container
  [ngTemplateOutlet]="template"
[ngTemplateOutletContext]="{
  schema: schema$ | async,
  costOverrides : costOverrides$ | async
}"
  >
</ng-container>

<ng-template
  #template
  let-schema="schema"
  let-costOverrides="costOverrides"
  >

  <mat-toolbar>
    <span>{{ schema?.title || 'Cost Overrides' }}</span>
    <span mat-spacer></span>
    <button type="button" mat-raised-button color="primary" (click)="addOverride()">
      Add
    </button>
  </mat-toolbar>
  <div class="table-container">
    <mat-table [dataSource]="costOverrides">
      <ng-container matColumnDef="caseTypeId">
        <mat-header-cell *matHeaderCellDef> Opinion Type </mat-header-cell>
        <mat-cell *matCellDef="let row">
          {{ row.caseTypeId | caseTypeDisplay | async }}
          <ng-template #loading>
            <mat-spinner [diameter]="14"></mat-spinner>
          </ng-template>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="active">
        <mat-header-cell *matHeaderCellDef> Active </mat-header-cell>
        <mat-cell *matCellDef="let row">
          @if (row.active) {
            <mat-icon color="accent" matTooltip="Active">toggle_on</mat-icon>
          }
          @if (!row.active) {
            <mat-icon matTooltip="Inactive">toggle_off</mat-icon>
          }
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="fee">
        <mat-header-cell *matHeaderCellDef> Fee </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{ row.fee }} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="actions" stickyEnd="true">
        <mat-header-cell *matHeaderCellDef> Actions</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <button type="button" mat-icon-button [disableRipple]="true" color="primary" (click)="updateOverride(row)">
            <mat-icon>edit</mat-icon>
          </button>
          <button type="button" mat-icon-button [disableRipple]="true" color="warn" (click)="deleteOverride(row.caseTypeId)">
            <mat-icon>delete_forever</mat-icon>
          </button>
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="['caseTypeId', 'active', 'fee', 'actions']"></mat-header-row>
      <mat-row *matRowDef="let row; columns: ['caseTypeId', 'active', 'fee', 'actions']"></mat-row>
    </mat-table>
  </div>
</ng-template>
